module.exports = __webpack_public_path__ + "static/ppe4all-1d79777fcdf9a9ff4dc0ec2939a8be56.png";